/*
 * @Description: 导入某个语种的所有语言包文件。
 * @Author: tao.zhu
 * @Date: 2018-09-14 12:42:48
 * @Last Modified by: tao.zhu
 * @Last Modified time: 2018-09-17 01:44:28
 */

/**
 *
 * 将某种语言的所有包集合在一个对象里面。
 * @param {funtion} {pack} 由require.context生成的方法。
 * @param {object} {extraArray} 由pack生成对象后，将extraArray as
 * @returns {object} 完整语言包对象。
 */
function getTheLang({ pack, extraArray }) {
  const cache = {};
  if (pack) {
    pack.keys().forEach((key) => {
      const context = pack(key);
      Object.assign(cache, context.default || context);
    });
  }
  // add extra lang object
  Object.assign(cache, ...extraArray);
  return cache;
}
export default getTheLang;
